import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CompanyCrew from '@legacy-components/company/CompanyCrew';
import Profile from '@legacy-components/company/Profile';
import Welcome from '@legacy-components/company/Welcome';
import CompanyCateringOverview from '@legacy-components/company/catering/CompanyCateringOverview';
import CompanyCompanyDetails from '@legacy-components/company/company/CompanyCompanyDetails';
import CompanySubContractors from '@legacy-components/company/company/CompanySubContractors';
import DownloadVouchers from '@legacy-components/company/crew/DownloadVouchers';
import CompanyEmployeeCertificates from '@legacy-components/company/employees/CompanyEmployeeCertificates';
import CompanyEmployeesCreateUpdate from '@legacy-components/company/employees/CompanyEmployeesCreateUpdate';
import CompanyEmployeesList from '@legacy-components/company/employees/CompanyEmployeesList';
import CompanyEmployeesNin from '@legacy-components/company/employees/CompanyEmployeesNIN';
import FrequentPassageRequestsList from '@legacy-components/company/frequentPassages/FrequentPassageRequestsList';
import CompanyGatekeepingOverview from '@legacy-components/company/gatekeeping/CompanyGatekeepingOverview';
import CompanyMaterialOverview from '@legacy-components/company/materials/CompanyMaterialOverview';
import CompanySecurityQuestions from '@legacy-components/company/securityQuestions/CompanySecurityQuestions';

import { ListRegistrationParkingRequests } from '@company/registration-parking-requests/views/ListRegistrationParkingRequests';

export function CompanyRoutes() {
  return (
    <Switch>
      <Route path="/download-vouchers/:registrationId" component={DownloadVouchers} />

      <Route path="/profile" component={Profile} />
      <Route path="/crew" component={CompanyCrew} />

      <Route exact path="/company" component={CompanyCompanyDetails} />
      <Route exact path="/company/subcontractors/create" component={CompanySubContractors} />
      <Route exact path="/company/subcontractors/:id/edit" component={CompanySubContractors} />
      <Route exact path="/company/employees" component={CompanyEmployeesList} />
      <Route exact path="/company/employees/create" component={CompanyEmployeesCreateUpdate} />
      <Route exact path="/company/employees/nin" component={CompanyEmployeesNin} />
      <Route exact path="/company/employees/:id/edit" component={CompanyEmployeesCreateUpdate} />
      <Route exact path="/company/employees/:id/certificates" component={CompanyEmployeeCertificates} />
      <Route exact path="/company/security-questions" component={CompanySecurityQuestions} />

      <Route exact path="/catering" component={CompanyCateringOverview} />
      <Route exact path="/parking" component={ListRegistrationParkingRequests} />
      <Route exact path="/materials" component={CompanyMaterialOverview} />
      <Route exact path="/gatekeeping" component={CompanyGatekeepingOverview} />
      <Route exact path="/frequent-passage-requests" component={FrequentPassageRequestsList} />

      {/* @ts-ignore-next */}
      <Route path="/" component={Welcome} />
    </Switch>
  );
}
